module.exports = __webpack_public_path__ + "img/4ab67ab.svg";